import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { connect } from "react-redux";
import { styles } from "./EnergyServicesHomeStyles";
import Header from "../components/Header";
import AssistedLivingNavigation from "../components/AssistedLivingNavigation";
import Loading from "../components/Loading";
import PageTitle from "../components/PageTitle";
import AlertDetailItem from "../components/AlertDetailItem";
import AlertEnd from "../components/AlertEnd";
import moment from "moment";
import PopupWrapper from "../components/PopupWrapper";

import { activityDetailActions } from "../_actions";

class AssistedLivingActivityAlert extends Component {
  constructor(props) {
    super(props);

    const params = new URLSearchParams(props.location.search);
    props.dispatch(
      activityDetailActions.getDetail(
        props.authentication.user.dependant_user_id,
        props.match.params.activity_id,
        params.get("on"),
        params.get("off")
      )
    );
  }

  render() {
    const { fetchingDetail, detail } = this.props;

    const activity_type = detail.activity && detail.activity.activity_type;
    const timestamp =
      detail.alerts && detail.alerts[0] && detail.alerts[0].timestamp;
    const isToday = timestamp && moment.unix(timestamp).isSame(moment(), "day");

    const params = new URLSearchParams(this.props.location.search);

    return (
      <div>
        <Header
          title={"Parent's Home"}
          backTitle={"Dashboard"}
          isAssistedLiving={true}
          backHref={"/"}
        />
        <PageTitle
          title={`${activity_type} Activity`}
          subTitle={`${
            !timestamp
              ? ""
              : isToday
              ? "today"
              : moment.unix(timestamp).format("Do MMMM")
          }`}
        />
        <AssistedLivingNavigation {...this.props.location} />
        <div className={css(styles.container)}>
          <PopupWrapper />
          {fetchingDetail && <Loading />}
          {!fetchingDetail && (
            <div>
              <div>
                {detail.alerts && detail.alerts.length ? (
                  detail.alerts.map((item, i) => {
                    return (
                      <AlertDetailItem
                        key={i}
                        {...item}
                        user={this.props.authentication.user}
                        dispatch={this.props.dispatch}
                      />
                    );
                  })
                ) : (
                  <AlertEnd {...detail.alerts} />
                )}
              </div>
              <a
                href={`/parents-home/activities/${
                  this.props.match.params.activity_id
                }?on=${moment
                  .unix(params.get("on"))
                  .startOf("day")
                  .unix()}&off=${moment
                  .unix(params.get("on"))
                  .endOf("day")
                  .unix()}`}
                className={css(styles.buttonGreen)}
              >{`View ${activity_type} Activity`}</a>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { fetchingDetail, detail } = state.activityDetail;
  const { alert, authentication } = state;
  return {
    fetchingDetail,
    detail,
    alert,
    authentication
  };
}

export default connect(mapStateToProps)(AssistedLivingActivityAlert);
